import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddHomeTutorPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();
  const [packageName, setPackageName] = useState();
  const [description, setDescription] = useState();
  const [mrp, setMrp] = useState();
  const [sellPrice, setSellPrice] = useState();
  const [numberOfLeads, setNumberOfLeads] = useState();
  const [validity, setValidity] = useState();
  const [icon, setIcon] = useState(null);

  const handleAddNewPrice = () => {
    navigate("/add-home-tutor-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/all-home-tutor-pricing");
  };

  const formData = new FormData();
  formData.append("packageName", packageName);
  formData.append("description", description);
  formData.append("mrp", mrp);
  formData.append("sellPrice", sellPrice);
  formData.append("numberOfLeads", numberOfLeads);
  formData.append("validity", validity);
  if (icon) {
    formData.append("icon", icon);
  }
  formData.forEach((item) => {
    console.log(item);
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${API_BASE_URL}/admin/package`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response);
        alert("Home Tutor Price Added Successfully.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while adding Price.");
      });
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Home Tutor Package</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewPrice}>
              + Add Price
            </button>
            <button className="allSubjects" onClick={handleViewAllPrice}>
              All Price
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Price Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Package Name :</label>
              </div>
              <input
                type="text"
                placeholder="Enter Package Name"
                value={packageName}
                onChange={(e) => setPackageName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Description :</label>
              </div>
              <input
                type="text"
                placeholder="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Mrp :</label>
              </div>
              <input
                type="text"
                placeholder="Enter mrp"
                value={mrp}
                onChange={(e) => setMrp(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Sell Price :</label>
              </div>
              <input
                type="text"
                placeholder="Sell Price"
                value={sellPrice}
                onChange={(e) => setSellPrice(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Number Of Leads :</label>
              </div>
              <input
                type="text"
                placeholder="Number Of Leads"
                value={numberOfLeads}
                onChange={(e) => setNumberOfLeads(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Validity :</label>
              </div>
              <input
                type="text"
                placeholder="Validity (in months)"
                value={validity}
                onChange={(e) => setValidity(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Icon :</label>
              </div>
              <input
                type="file"
                onChange={(e) => setIcon(e.target.files[0])} // Correct way to handle file input
                required
              />
            </div>

            <div className="school-subj-form-btns">
              <button
                className="btn-search"
                type="submit"
                // onClick={handleSubmit}
              >
                Save
              </button>
              <button className="btn-cancel">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddHomeTutorPricing;
